import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { PermissionOrderField } from "permissions/_api/queries/ordering/permission-order-params";
import { z } from "zod";

export type PermissionOrderParameters = z.infer<typeof PermissionOrderSchema.PermissionOrderZ>;

export default class PermissionOrderSchema {
  public static readonly PermissionOrderZ = z
    .object({
      orderBy: z.enum(PermissionOrderField).optional(),
      orderDir: z.enum(OrderDirection).optional(),
    })
    .optional();

  public static create(values: PermissionOrderParameters): PermissionOrderParameters {
    return parseOrThrow(PermissionOrderSchema.PermissionOrderZ, values, {
      logError: true,
      schemaName: "PermissionOrder",
      operation: "create",
      payloadSample: values,
    });
  }
}
